module.exports = new __parcel__URL__("graph-cursor.8e1414e0.png").toString();